import React, { useMemo } from 'react'
import { useApiFormNodeLibrary, useApiFormNodeMove, useApiListNodeLibrary, useApiListNodeLibraryCategory } from '../../../../../../api-new/state/content'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { IconMove } from '../../../../../../shared/icon/icon'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { LibraryMenu } from '../../common/menu/node-actions'
import { buildLibraryPath } from '../../common/shared/build-path'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleHiddenNumber } from '../../../../../../shared/form-simple/form-hidden-number'
import { FormSimpleCategorySelectFilter } from '../../../../../../shared/form-simple/form-category-select-filter'
import { FormSimpleSubmitEdit } from '../../../../../../shared/form-simple/form-submit'

export const NodeLibraryMove = ({ parentURL, nodeID }) => {
  const history = useHistory()

  const apiFormNodeLibrary = useApiFormNodeLibrary()
  const apiFormNodeMove = useApiFormNodeMove()
  const apiListNodeLibrary = useApiListNodeLibrary()

  const title = useMemo(() => apiFormNodeLibrary.form.name, [apiFormNodeLibrary.form])

  const handleMatch = async () => await apiFormNodeLibrary.get(nodeID)

  const handleSubmit = async data => {
    if (data.parentID === -1) {
      data.parentID = null
    }

    await apiFormNodeMove.put(data.nodeID, data)
    const nodes = await apiListNodeLibrary.get(`ancestors/${data.nodeID}`)
    const path = buildLibraryPath(nodes, data.nodeID)
    history.replace(path)
  }

  const HeaderMenu = () => <LibraryMenu place="header" url={parentURL} />

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconMove} text="move" onMatch={handleMatch}>
        <CardFullHeightScrollY title={title} HeaderMenu={HeaderMenu}>
          <FormSimple onSubmit={handleSubmit}>
            <FormSimpleHiddenNumber name="nodeID" value={apiFormNodeLibrary.form.id} required />
            <FormSimpleCategorySelectFilter name="parentID" label="category" rootName="LIBRARY" useApiListCategory={useApiListNodeLibraryCategory} required />
            <FormSimpleSubmitEdit text="move library" backURL={parentURL} />
          </FormSimple>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
